<template>
  <div
    v-if="partnersSettings.displayMode == 0"
    class="md-layout-item md-size-100"
    style="padding:0px"
  >
    <div class="md-card" style="margin:20px 0px 20px 0px">
      <div class="md-layout" style="margin-bottom:0px; padding:10px 10px">
        <div class="md-layout-item md-size-20 md-medium-size-33 md-xsmall-size-90">
          <img :src="logoUrl" style="max-width:200px;margin-bottom:20px;border-radius:0px" />
        </div>
        <div class="md-layout-item" style="margin-left:20px">
          <a
            v-if="item.description.url"
            :href="item.description.url"
            target="_blank"
            class="text-primary"
          >
            <h3 class="bold text-primary" style="margin:-5px 0px 0px 0px">{{item.description.name}}</h3>
          </a>
          <h3
            class="bold text-primary"
            style="margin:-5px 0px 0px 0px"
            v-else
          >{{item.description.name}}</h3>

          <div
            class="text-gray regular"
            style="font-size:14px; margin:5px 10px 0px 0px"
          >{{item.description.description}}</div>
        </div>
      </div>
      <div class="md-layout md-layout-item md-size-100" style="margin-bottom:5px;margin-top:0px">
        <div class="ml-auto">
          <md-button
            @click.prevent="gotoDetails"
            class="md-round md-primary md-sm md-blue-border"
            style="margin:0px 10px"
          >{{$t('Go to details')}}</md-button>
        </div>
      </div>
    </div>
  </div>

  <div v-else-if="partnersSettings.displayMode == 1" class="md-layout-item md-size-100 item">
    <h4 class="text-primary regular" @click="gotoDetails">{{item.description.name}}</h4>
  </div>

  <div
    v-else
    class="md-layout-item md-size-25 md-medium-size-50 md-xsmall-size-100"
    style="padding:10px"
  >
    <img :src="logoUrl" style="width:100%;cursor:pointer" @click="gotoDetails" />
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import axios from "@/util/axios";

export default {
  props: ["item"],
  computed: {
    ...mapGetters({
      conference: "conference/current",
      partnersSettings: "user/partnersSettings"
    }),

    logoUrl() {
      return axios.getFileUrl(this.item.description.logoId);
    }
  },

  methods: {
    gotoDetails() {
      this.$router.push({
        name: "partnerDetails",
        params: { id: this.item.id }
      });
    }
  },
  data() {
    return {};
  }
};
</script>

<style lang="scss" scoped>
.justify-content-center {
  justify-content: center !important;
}
.md-card-horizontal .md-card-header-image {
  margin-bottom: 1rem;
}

.md-card {
  margin: 10px 0px;
  padding: 10px;
  box-shadow: 0px 0px 30px #0000001a;
  border-radius: 30px;
  opacity: 1;
}

.item {
  cursor: pointer;
  &:hover {
    box-shadow: 0px 0px 30px #0000000d;
    border-radius: 15px;
    opacity: 1;
  }

  h4 {
    margin: 0px 7px;
    padding: 7px 0px;
  }
}
</style>



